import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/offer.css";
import "../../assets/css/general.css";
import "../../assets/css/hamburger.css";

import Hero from "../../components/offer/hero.jsx";
import Card from "../../components/general/listCard.jsx";
import Tool from "../../components/general/tool.jsx";
import Footer from "../../components/general/footer.jsx";

const Offer = () => {
  const offers = [
    {
      id: 1,
      title: "Cuisinier en restauration",
      subtitle: "Restauration collective & Caterina",
      location: "Nice (06)",
      time: "Il y a 20 minutes",
    },
    {
      id: 2,
      title: "Serveur/Serveuse en restaurant",
      subtitle: "Restauration traditionnelle & Le Bistrot",
      location: "Lyon (69)",
      time: "Il y a 1 heure",
    },
    {
      id: 3,
      title: "Chef de rang",
      subtitle: "Hôtellerie haut de gamme & L'Excellence",
      location: "Paris (75)",
      time: "Il y a 2 jours",
    },
    {
      id: 4,
      title: "Plongeur(se)",
      subtitle: "Restauration rapide & FastFood Express",
      location: "Marseille (13)",
      time: "Il y a 3 heures",
    },
    // ... autres offres
  ];

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="main">
      <Hero />
      <Card offers={offers} listName="Offres" variant="offres" />
      <Tool />
      <Footer />
    </div>
  );
};

export default Offer;
